/**
 * Put the observed envelope shape somewhere a person will actually see it.
 *
 * This is a one-question instrument, not a feature: the gateway can emit the
 * judgment as `parts[0].data` or as a JSON string in `parts[0].text`, and the
 * agent channel could not establish which one this skill takes. One real
 * review answers it. The report never reads a payload, so there is no parser
 * here to be wrong.
 *
 * Remove this once the response contract is published and Studio reads the
 * judgment for real — an instrument left behind after its question is answered
 * becomes noise, and then becomes something nobody reads.
 */
import type { ReviewEnvelopeReport } from './review-envelope-shape'

export const REVIEW_ENVELOPE_LOG_TAG = '[preview-review-envelope]'

export function reportReviewEnvelope(report: ReviewEnvelopeReport): void {
  // eslint-disable-next-line no-console -- the observation IS the deliverable
  console.info(REVIEW_ENVELOPE_LOG_TAG, JSON.stringify(report))
}
